import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const ExpenseIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.79999 6.39993C7.79999 6.06856 8.06861 5.79993 8.39999 5.79993H10.2C10.5314 5.79993 10.8 6.06856 10.8 6.39993C10.8 6.7313 10.5314 6.99993 10.2 6.99993H8.39999C8.06861 6.99993 7.79999 6.7313 7.79999 6.39993Z"
				fill="#4C4C58"
			/>
			<path
				d="M8.40002 9.19991C8.40002 8.86854 8.66865 8.59991 9.00002 8.59991H13.8C14.1314 8.59991 14.4 8.86854 14.4 9.19991C14.4 9.53129 14.1314 9.79991 13.8 9.79991H9.00002C8.66865 9.79991 8.40002 9.53129 8.40002 9.19991Z"
				fill="#4C4C58"
			/>
			<path
				d="M9.00002 11.3999C8.66865 11.3999 8.40002 11.6685 8.40002 11.9999C8.40002 12.3313 8.66865 12.5999 9.00002 12.5999H13.8C14.1314 12.5999 14.4 12.3313 14.4 11.9999C14.4 11.6685 14.1314 11.3999 13.8 11.3999H9.00002Z"
				fill="#4C4C58"
			/>
			<path
				d="M8.40002 14.8C8.40002 14.4686 8.66865 14.2 9.00002 14.2H13.8C14.1314 14.2 14.4 14.4686 14.4 14.8C14.4 15.1313 14.1314 15.4 13.8 15.4H9.00002C8.66865 15.4 8.40002 15.1313 8.40002 14.8Z"
				fill="#4C4C58"
			/>
			<path
				d="M9.00002 16.9999C8.66865 16.9999 8.40002 17.2686 8.40002 17.5999C8.40002 17.9313 8.66865 18.1999 9.00002 18.1999H11.4C11.7314 18.1999 12 17.9313 12 17.5999C12 17.2686 11.7314 16.9999 11.4 16.9999H9.00002Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.4 2.99994C6.7828 2.99994 5.4 4.23313 5.4 5.83994V17.0399C5.4 18.0442 5.13505 18.6147 4.80332 18.9846C4.45387 19.3743 3.9694 19.6129 3.38283 19.8406C3.11364 19.9451 2.95709 20.2266 3.01026 20.5104C3.06342 20.7942 3.31123 20.9999 3.6 20.9999H13.2C15.4799 20.9999 17.4 19.2653 17.4 17.0399V9.23996H20.4C20.7314 9.23996 21 8.97133 21 8.63996V5.39994C21 4.0751 19.9265 3.00098 18.6019 2.99994L18.6 2.99994H8.4ZM16.5211 4.19994H8.4C7.36622 4.19994 6.6 4.97251 6.6 5.83994V17.0399C6.6 18.2756 6.26495 19.1522 5.69667 19.7858L5.68394 19.7999H13.2C14.8965 19.7999 16.2 18.5259 16.2 17.0399V8.63994L16.2 8.63604V5.39994C16.2 4.9628 16.3169 4.55295 16.5211 4.19994ZM18.6 4.19994C17.9373 4.19995 17.4 4.7372 17.4 5.39994V8.03996H19.8V5.39994C19.8 4.7372 19.2627 4.19994 18.6 4.19994Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

ExpenseIcon.propTypes = iconPropTypes;
ExpenseIcon.defaultProps = iconDefaultProps;
